<template>
  <b-col sm="12" :lg="lgSize">
    <div class="animated fadeIn">
      <DateModal
        modalID="delivered_total_email"
        :fetchData="fetchData"
        :dateFrom="dateFrom"
        :dateTo="dateTo"
        @date-picker-modal-emit="onDatePickerModalEmit"
      ></DateModal>

      <b-card class="backClass" style="height:450px" header="Received">
        <div slot="header" style="display:flex;justify-content: space-between;">
          <div style="display:flex;">
            <HeaderTitle
              title="Delivered By Email"
              :dateFrom="
                from(dateFrom)
                  ? $formatUSDate(from(dateFrom))
                  : $formatUSDate(dateFrom)
              "
              :dateTo="
                to(dateTo) ? $formatUSDate(to(dateTo)) : $formatUSDate(dateTo)
              "
            ></HeaderTitle>
            <HeaderControl
              :showDateIcon="true"
              @emit-date="modalDateEvent"
            ></HeaderControl>
          </div>
          <div style="width:auto">
            <b-input-group size="sm">
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Type to Search"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''"
                  >Clear</b-button
                >
              </b-input-group-append>
            </b-input-group>
          </div>
        </div>
        <div class>
          <LoadingCard v-if="loadingData"></LoadingCard>
          <div v-else>
            <b-table
              responsive
              style="height:350px"
              :filter="filter"
              :fields="fields"
              size="lg"
              :items="items"
            >
              <template v-slot:cell(courier_image)="{ value }">
                <img :src="value" width="40px" style="border-radius: 100px;" />
              </template>
              <template v-slot:cell(trackingLink)="row">
                <a :href="row.item.outTrackLink" download>
                  {{ row.item.outTrack }}
                </a>
              </template>
              <template v-slot:cell(download)="row">
                <b-button
                  @click="
                    downloadReport(
                      row.item.ranum,
                      row.item.shipDate.slice(0, 10)
                    )
                  "
                  size="sm"
                  class="mr-1"
                >
                  <i class="fa fa-download" aria-hidden="true"></i>
                </b-button>
              </template>
            </b-table>
          </div>
        </div>
        <b-modal
          :id="infoModal.id"
          :title="infoModal.title"
          ok-only
          @hide="resetInfoModal"
        >
          <img :src="infoModal.content" width="100%" />
        </b-modal>
      </b-card>
    </div>
  </b-col>
</template>

<script>
import { Chart } from "highcharts-vue";
import router from "../../router";
import Datepicker from "vuejs-datepicker";
import cTable from "../../views/base/tables/Table";
import DateModal from "../shared/DateModal.vue";
import HeaderTitle from "../shared/HeaderTitle.vue";
import HeaderControl from "../shared/HeaderControl.vue";
import LoadingCard from "../shared/LoadingCard.vue";
import { from, isUserLoggedIn, to } from "../../utils/Utils";

export default {
  name: "DeliveredTotalByEmail",
  components: {
    router,
    cTable,
    highcharts: Chart,
    Datepicker,
    DateModal,
    HeaderTitle,
    HeaderControl,
    LoadingCard
  },
  props: ["lgSize", "lgOffset", "locParam", "idCity", "nameCity"],
  data: function() {
    return {
      from: from,
      to: to,
      filter: null,
      fullscreen: false,
      loadingData: false,
      showAll: false,
      modalDate: false,
      dateFrom: "",
      dateTo: "",
      city: "",
      locationName: "",
      productGroup: "",
      locationsIds: "",
      title: "",
      items: [],
      fields: [
        { key: "courier_image", label: "" },
        { key: "deliveryType", label: "Delivery Type" },
        { key: "fnsid", label: "FNSID" },
        { key: "ranum", label: "RMA" },
        {
          key: "shipDate",
          label: "Ship Date",
          formatter: (value, key, item) => {
            return this.$formatUSDate(item.shipDate);
          }
        },
        { key: "trackingLink", label: "Tracking" },
        { key: "download", label: "Download Report" }
      ],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  methods: {
    onDatePickerModalEmit(changedDateFrom, changedDateTo) {
      this.dateFrom = changedDateFrom
        ? new Date(changedDateFrom).toISOString().split("T")[0]
        : changedDateFrom;
      this.dateTo = changedDateTo
        ? new Date(changedDateTo).toISOString().split("T")[0]
        : changedDateTo;
    },
    modalDateEvent() {
      this.$bvModal.show("delivered_total_email");
    },
    downloadReport(ranum, shipDate) {
      window.location.href =
        process.env.VUE_APP_TRACKER_URL +
        "tracker_private/spreadsheets/shippingRecordByDatePublic.php?date=" +
        shipDate +
        "&ranum=" +
        ranum;
    },
    info(item, index, button) {
      this.infoModal.title = `RMA: ${item.ranum}`;
      this.infoModal.content = item.image;
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    fetchData() {
      this.loadingData = true;
      let params = {};
      params = {
        clients: this.locationsIds,
        date_from: this.dateFrom,
        date_to: this.dateTo
      };
      this.$http
        .get("api/tables/delivery_courier.php", {
          params
        })
        .then(
          res => {
            this.loadingData = false;
            this.title = "Total records: " + res.data.count;
            this.items = res.data.records;
          },
          err => {
            this.loadingData = false;
            console.log(err);
          }
        );
    }
  },
  mounted() {
    isUserLoggedIn(router);
    const date = new Date();
    date.setDate(date.getDate() - 30);
    this.dateFrom = date.toISOString().split("T")[0];
    this.dateTo = new Date().toJSON().slice(0, 10);
    this.locationsIds = localStorage.getItem("locations");
    this.fetchData();
  }
};
</script>

<style>
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
</style>
